// import {TweenMax} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import isMobile from './is-mobile.js';
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


var controller = new ScrollMagic.Controller();

let targets = document.querySelectorAll('.js-fadeIn')


for (let target of targets) {

  var scene_career_list = new ScrollMagic.Scene({
    triggerElement: target,
    triggerHook: 'onCenter',
    offset: '-100px'
  })
    .addTo(controller);

  scene_career_list.on('enter', () => {
    var tl = new TimelineMax();

    tl
      .to(target, 1, { y: "0px", alpha: 1, ease: Sine.easeOut });

    // target.classList.add('is-animated');
  });

}
let studios = document.querySelectorAll('.js-fadeIn_studio')

for (let studio of studios) {

  var scene_career_list = new ScrollMagic.Scene({
    triggerElement: studio,
    triggerHook: 'onCenter',
    offset: '-100px'
  })
    .addTo(controller);

  scene_career_list.on('enter', () => {
    var tl = new TimelineMax();
    if (!isMobile(768))
    {
      tl.to(studio, 1, { y: "0", alpha: 1, ease: Sine.easeOut });
    } else { 
      tl.to(studio, 1, { y: "-50px", alpha: 1, ease: Sine.easeOut });
    }

    // target.classList.add('is-animated');
  });

}
